/**
 * Concatenates a root path and an array of route segments to form a complete URL path.
 *
 * @param root The root path
 * @param routes An array of route segments
 * @returns The complete URL path
 *
 * @example
 * const routes = ['account', 'profile'];
 * const result1 = urlPath('https://example.com', routes);
 * // result1 -> 'https://example.com/stay/guest-hub'
 * const result2 = urlPath('/', ['account', 'profile']);
 * // result2 -> '/account/profile'
 */
export const urlPath = (root: string, routes: string[]) => [root, ...routes].join('/');

/**
 * Generates the URL based on the provided route segments.
 * Useful for children routes
 * @param routes An array of route segments.
 *
 * @example
 * const result = buildAccountUrl('account', 'mobile', ['language'])
 * // result -> /account/mobile/language
 */
export const buildUrl = (parentRoot: string, root: string, routes: string[]) =>
  urlPath('/' + parentRoot + '/' + root, routes);
